module.exports = __webpack_public_path__ + "static/media/gene.25b2ca99.svg";